module.exports = __webpack_public_path__ + "static/media/Eclipse Vieitez.898f7078.mp4";